<template>
  <div class="cf-subheaderWrap padding-tb-24">
    <h3>
      {{title}}
      <mds-button
        type="button"
        variation="icon-only" icon="info-circle"
        @mouseover="toggle = true"
        @mouseleave="toggle = false"
        @focus="toggle = true"
        @blur="toggle = false"
        id="default-trigger"
        >info</mds-button
      >
    
      <mds-tooltip
        triggered-by="default-trigger"
        v-model="toggle"
        :position="['right-center']"
      >
       {{tootlTipText}}
      </mds-tooltip>
    </h3>

    <div class="cf-supportingText padding-tb-8">
      {{subTitle}}
    </div>
  </div>
</template>

<script>
import MdsTooltip from "@mds/tooltip";
import { MdsButton } from "@mds/button";

export default {
  name: "cf-Sub-header",
  components: {
    MdsTooltip,
    MdsButton,
  },
  props:[
    'title',
    'subTitle',
    'tootlTipText'
],
  data() {
    return {
      toggle: false,

  
    };
  },
};
</script>

<style lang="scss" scoped>
.cf-subheaderWrap {
  .cf-supportingText {
    @include mds-level-5-heading();
  }
}
</style>